import { j as a } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import { a as X, b as L, e as z, N as ee } from "../../chunks/Nav.D7EuGsBi.js";
import { c as F } from "../../chunks/index.CxSWpsOB.js";
import { u as y, C as b, N as M, A as v, a as o, b as g, I as O, L as e, S as C, V as Z } from "../../chunks/IntlGlobalMessages.DP29fCHC.js";
import * as k from "react";
import J, { forwardRef as Ae, useState as q, useEffect as me } from "react";
import { B as j } from "../../chunks/Button.Ccj-dDdM.js";
import { a as re, j as de, c as le, f as ae, b as se } from "../../chunks/Drawer.DJSM1vCc.js";
import { F as ie } from "../../chunks/X24.CNnx-_EL.js";
import { A as Ie, b as xe, a as Oe } from "../../chunks/Avatar.DWv-3vyX.js";
import { F as oe } from "../../chunks/ChevronDown20.NQYj4T82.js";
import { D as ce, a as ue, b as pe, i as _e, c as Se, g as Le, k as Te, m as ve, j as ge, l as Ce } from "../../chunks/DropdownMenu.D4InU11_.js";
import { F as Re } from "../../chunks/Search20.DPh0h8Ck.js";
import { T as ye } from "../../chunks/Text.BGhoO_e3.js";
import { P as be, d as je, c as De, b as Me, a as He } from "../../chunks/Popover.IWkkIIzd.js";
import { Breakpoints as Be } from "../../foundations/breakpoints/index.js";
import { F as Ue } from "../../chunks/X16.DHZc2Acw.js";
import { u as Pe } from "../../chunks/use-media-query.CzJ6WnFm.js";
import "../../chunks/_baseToString.B41tpU4a.js";
import { A as Ge, b as Ve, c as Ye, a as We } from "../../chunks/Accordion.nAcmdOfN.js";
const R = {
  ACTIVITIES: "see_all_activities",
  IDEAS: "see_all_ideas",
  VENDORS: "see_all_vendors",
  LOCATIONS: "see_all_locations",
  SEE_ALL: "see_all"
}, p = {
  EN_US: "en-US",
  FR_FR: "fr-FR",
  DE_DE: "de-DE",
  ES_ES: "es-ES",
  EN_AU: "en-AU",
  EN_CA: "en-CA",
  EN_GB: "en-GB"
}, W = {
  MAIN: "main",
  BROWSE: "browse"
}, $ = ({
  intl: n,
  messageCount: i,
  urlPrefix: s = "",
  myListingsBadge: r,
  addOnsBadge: d,
  zendeskLocale: l = "en-us",
  logOutUser: c,
  analyticsTrackFunction: u
}) => {
  const {
    formatComponentMessage: t
  } = y(b.NAVIGATION, n), {
    EARN_50: S,
    HOST_HUB: f,
    INBOX: h,
    BOOKINGS: w,
    BOARDS: A,
    REVIEWS: I,
    PROFILE: _,
    PAYMENTS: N,
    LOGOUT: x,
    LIST_SPACE: m,
    HELP: T,
    LISTINGS: D,
    CALENDAR: H,
    ADD_ONS: V,
    COMMUNITY: K,
    NEW: Y
  } = M;
  return {
    [S]: {
      id: "header_link_referrals",
      dataTestId: S,
      display: t(S),
      url: "/referrals",
      onClick: u,
      className: "tw-hidden lg:tw-flex"
    },
    [f]: {
      id: f,
      dataTestId: f,
      display: t(f),
      url: "/host-hub",
      className: "tw-hidden lg:tw-flex",
      badge: {
        display: t(Y),
        className: "tw-inline-flex tw-h-24 tw-px-8 tw-items-center tw-justify-center tw-bg-purple-600 tw-text-brand-white tw-text-[10px] tw-font-bold tw-rounded-full tw-whitespace-nowrap"
      }
    },
    [h]: {
      id: h,
      dataTestId: h,
      display: t(h),
      url: "/inbox",
      className: "tw-hidden lg:tw-flex",
      badge: i ? {
        display: i.toString(),
        className: F("tw-bg-purple-600 tw-text-brand-white tw-rounded-full tw-text-xs tw-font-medium tw-min-w-20 tw-h-20 tw-flex tw-items-center tw-justify-center tw-p-10", {
          "tw-py-6 tw-px-6": i > 9,
          "tw-py-8 tw-px-8": i > 99
        })
      } : void 0
    },
    [w]: {
      id: w,
      dataTestId: w,
      display: t(w),
      url: "/bookings",
      className: "tw-hidden lg:tw-flex"
    },
    [A]: {
      id: A,
      dataTestId: A,
      display: t(A),
      url: "/boards",
      className: "tw-hidden lg:tw-flex"
    },
    [I]: {
      id: I,
      dataTestId: I,
      display: t(I),
      url: "/reviews/about-you"
    },
    [_]: {
      id: _,
      dataTestId: _,
      display: t(_),
      url: "/profile"
    },
    [N]: {
      id: N,
      dataTestId: N,
      display: t(N),
      url: "/account"
    },
    [m]: {
      id: m,
      dataTestId: m,
      display: t(m),
      url: `${s}/host`,
      appearance: "purple"
    },
    [T]: {
      id: T,
      dataTestId: T,
      display: t(T),
      url: `https://support.peerspace.com/hc/${l}`
    },
    [D]: {
      id: D,
      dataTestId: D,
      display: t(D),
      url: "/mylistings",
      className: "tw-hidden lg:tw-flex",
      badge: r ? {
        display: t(Y),
        className: "tw-text-purple-600 tw-body-1-m"
      } : void 0
    },
    [H]: {
      id: H,
      dataTestId: H,
      display: t(H),
      url: "/calendar",
      className: "tw-hidden xl:tw-flex"
    },
    [V]: {
      id: V,
      dataTestId: V,
      display: t(V),
      url: "/hosting/add-ons",
      className: "tw-hidden xxl:tw-flex",
      badge: d ? {
        display: t(Y),
        className: "tw-text-purple-600 tw-body-1-m"
      } : void 0
    },
    [K]: {
      id: K,
      dataTestId: K,
      display: t(K),
      url: "https://community.peerspace.com",
      className: "tw-hidden xxl:tw-flex"
    },
    [x]: {
      id: x,
      dataTestId: x,
      display: t(x),
      onClick: c
    }
  };
}, Fe = (n) => {
  const {
    EARN_50: i,
    INBOX: s,
    BOOKINGS: r,
    BOARDS: d,
    LISTINGS: l
  } = $(n);
  return [...n.showReferral ? [i] : [], s, r, d, ...n.isVendor ? [l] : []];
}, $e = (n) => {
  const {
    REVIEWS: i,
    PROFILE: s,
    PAYMENTS: r,
    LIST_SPACE: d,
    HELP: l,
    LOGOUT: c
  } = $(n);
  return [i, s, {
    ...r,
    divider: !0
  }, d, l, c];
}, Ke = (n) => {
  const {
    EARN_50: i,
    INBOX: s,
    BOOKINGS: r,
    BOARDS: d,
    REVIEWS: l,
    PROFILE: c,
    PAYMENTS: u,
    LIST_SPACE: t,
    HELP: S,
    LOGOUT: f,
    LISTINGS: h
  } = $(n);
  return [{
    ...s,
    className: "tw-flex"
  }, {
    ...r,
    className: "tw-flex"
  }, ...n.isVendor ? [{
    ...h,
    className: "tw-flex"
  }] : [], l, {
    ...d,
    className: "tw-flex"
  }, c, {
    ...u,
    divider: !0
  }, ...n.showReferral ? [{
    ...i,
    className: "tw-flex",
    divider: !0,
    appearance: "purple"
  }] : [], t, S, f];
}, Ze = (n) => {
  const {
    HOST_HUB: i,
    INBOX: s,
    BOOKINGS: r,
    LISTINGS: d,
    CALENDAR: l,
    ADD_ONS: c,
    COMMUNITY: u
  } = $(n);
  return [i, s, r, d, l, c, u];
}, ke = (n) => {
  const {
    HOST_HUB: i,
    CALENDAR: s,
    ADD_ONS: r,
    COMMUNITY: d,
    REVIEWS: l,
    BOARDS: c,
    PROFILE: u,
    PAYMENTS: t,
    EARN_50: S,
    LIST_SPACE: f,
    HELP: h,
    LOGOUT: w
  } = $(n);
  return [{
    ...i,
    className: "tw-flex lg:tw-hidden"
  }, {
    ...s,
    className: "tw-flex xl:tw-hidden"
  }, {
    ...r,
    className: "tw-flex xxl:tw-hidden"
  }, {
    ...d,
    className: "tw-flex xxl:tw-hidden"
  }, l, c, u, {
    ...t,
    divider: !0
  }, ...n.showReferral ? [{
    ...S,
    className: "tw-flex",
    divider: !0,
    appearance: "purple"
  }] : [], f, h, w];
}, Xe = (n) => {
  const {
    HOST_HUB: i,
    INBOX: s,
    BOOKINGS: r,
    LISTINGS: d,
    CALENDAR: l,
    ADD_ONS: c,
    COMMUNITY: u,
    REVIEWS: t,
    BOARDS: S,
    PROFILE: f,
    PAYMENTS: h,
    EARN_50: w,
    LIST_SPACE: A,
    HELP: I,
    LOGOUT: _
  } = $(n);
  return [{
    ...i,
    className: "tw-flex"
  }, {
    ...s,
    className: "tw-flex"
  }, {
    ...r,
    className: "tw-flex"
  }, {
    ...d,
    className: "tw-flex"
  }, {
    ...l,
    className: "tw-flex"
  }, {
    ...c,
    className: "tw-flex"
  }, {
    ...u,
    className: "tw-flex"
  }, t, {
    ...S,
    className: "tw-flex"
  }, f, {
    ...h,
    divider: !0
  }, ...n.showReferral ? [{
    ...w,
    className: "tw-flex",
    divider: !0,
    appearance: "purple"
  }] : [], A, I, _];
}, te = Ae(({
  avatarSrc: n,
  ...i
}, s) => /* @__PURE__ */ a.jsx(j, { ref: s, variant: "text-only", iconOnly: !0, appearance: "white", suffix: /* @__PURE__ */ a.jsx(oe, {}), ariaLabel: "Peerspace menu", className: "[&>.tw-inline-block]:tw-flex [&>.tw-inline-block]:tw-items-center [&>.tw-inline-block]:tw-justify-center", ...i, children: /* @__PURE__ */ a.jsx("div", { className: "tw-flex tw-items-center tw-justify-center tw-w-32 tw-h-32", children: /* @__PURE__ */ a.jsxs(Ie, { size: 24, className: "tw-border-2 tw-border-gray-900 tw-w-full tw-h-full", children: [
  /* @__PURE__ */ a.jsx(xe, { src: n ?? void 0, alt: "User avatar" }),
  /* @__PURE__ */ a.jsx(Oe, {})
] }) }) }));
te.displayName = "NavAvatarButton";
const Ee = ({
  avatarSrc: n,
  localeSelector: i,
  navLinks: s
}) => /* @__PURE__ */ a.jsxs(re, { activeSnapPoint: 1, children: [
  /* @__PURE__ */ a.jsx(de, { asChild: !0, children: /* @__PURE__ */ a.jsx(te, { avatarSrc: n }) }),
  /* @__PURE__ */ a.jsxs(le, { "data-test-id": "logged-in-nav-drawer-content", className: "tw-h-full tw-max-h-[97%] tw-mx-[-1px] tw-bg-base-black", children: [
    /* @__PURE__ */ a.jsx(ae, { className: "tw-text-left tw-p-24 tw-border-b tw-border-gray-700", children: /* @__PURE__ */ a.jsxs("div", { className: "tw-flex tw-items-center tw-justify-between [&>button]:tw-text-base-white [&>button]:hover:tw-text-gray-500 [&_svg]:tw-w-24 [&_svg]:tw-h-24", children: [
      i,
      /* @__PURE__ */ a.jsx(se, { children: /* @__PURE__ */ a.jsx(ie, { className: "tw-text-base-white" }) })
    ] }) }),
    /* @__PURE__ */ a.jsx("div", { className: "tw-p-24 tw-flex tw-flex-col tw-gap-y-32 tw-overflow-y-auto", children: s.map((r) => /* @__PURE__ */ a.jsxs(J.Fragment, { children: [
      /* @__PURE__ */ a.jsxs("div", { className: "tw-flex tw-items-center tw-gap-x-8", "data-test-id": r.dataTestId, children: [
        /* @__PURE__ */ a.jsx(j, { ...r.url && {
          href: r.url
        }, ...r.onClick && {
          onClick: (d) => r.onClick(d, r.id || "")
        }, ...r.id && {
          id: r.id
        }, variant: "text-only", appearance: r.appearance || "white", className: F("tw-text-left tw-justify-start tw-text-wrap tw-headline-2-m", r.className), children: r.display }),
        // make circle badge
        r.badge && /* @__PURE__ */ a.jsx("div", { className: r.badge.className, "data-test-id": "badge", children: r.badge.display })
      ] }),
      r.divider && /* @__PURE__ */ a.jsx("hr", { className: "tw-border-gray-700" })
    ] }, r.id)) })
  ] })
] }), Ne = ({
  avatarSrc: n,
  navLinks: i
}) => /* @__PURE__ */ a.jsxs(ce, { children: [
  /* @__PURE__ */ a.jsx(ue, { asChild: !0, children: /* @__PURE__ */ a.jsx(te, { avatarSrc: n }) }),
  /* @__PURE__ */ a.jsx(pe, { side: "bottom", align: "end", className: "tw-w-[200px]", children: /* @__PURE__ */ a.jsx(_e, { children: i.map((s) => /* @__PURE__ */ a.jsxs(J.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(Se, { className: F("tw-w-full tw-items-center tw-gap-x-8", s.className), children: [
      /* @__PURE__ */ a.jsx(j, { ...s.url && {
        href: s.url
      }, ...s.onClick && {
        onClick: (r) => s.onClick(r, s.id || "")
      }, ...s.id && {
        id: s.id
      }, variant: "text-only", appearance: s.appearance || "white", className: "tw-text-left tw-justify-start tw-text-wrap", children: s.display }),
      // make circle badge
      s.badge && /* @__PURE__ */ a.jsx("div", { className: s.badge.className, children: s.badge.display })
    ] }),
    s.divider && /* @__PURE__ */ a.jsx(Le, {})
  ] }, s.id)) }) })
] }), Je = (n, i) => /* @__PURE__ */ a.jsxs("svg", { width: 1450, height: 358, viewBox: "0 0 1450 358", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: i, ...n, children: [
  /* @__PURE__ */ a.jsxs("g", { clipPath: "url(#clip0_254_17087)", children: [
    /* @__PURE__ */ a.jsx("path", { d: "M88.87 3.71L0.599976 3.63V351.25L62.43 351.15L62.55 211.98L91.96 212.01C135.39 212.05 152.69 184.51 152.73 142.01L152.79 72.42C152.83 29.92 141.64 3.75 88.87 3.71ZM90.18 135.87C90.17 146.61 88.29 155.48 74.28 155.46H62.61L62.69 57.4H74.37C88.38 57.41 90.23 65.82 90.23 77.96L90.18 135.87Z", fill: "currentColor" }),
    /* @__PURE__ */ a.jsx("path", { d: "M233.3 203.23L286.54 203.27L286.59 140.69L233.35 140.65L233.41 64.99L304.02 65.05L304.07 3.87001H304.09L171.36 3.76001L171.07 351.23L304.17 351.34L304.22 288.76L233.23 288.7L233.3 203.23Z", fill: "currentColor" }),
    /* @__PURE__ */ a.jsx("path", { d: "M384.56 203.35L437.8 203.4L437.85 140.82L384.61 140.77L384.67 65.11L455.4 65.17L455.45 3.99H455.47L322.62 3.88L322.33 351.35L455.43 351.46L455.48 288.88L384.49 288.82L384.56 203.35Z", fill: "currentColor" }),
    /* @__PURE__ */ a.jsx("path", { d: "M627.8 205.43C627.82 179.28 611.48 168.05 601.21 164.31C612.89 159.65 628.78 145.65 628.8 117.63L628.85 62.05C628.88 25.15 609.75 4.12001 571.92 4.09001L473.84 4.01001L473.55 351.48L535.67 351.53L535.79 203.04H548.87C561.48 203.05 565.21 207.72 565.2 223.6L565.12 324.94C565.11 340.36 567.9 347.83 570.7 351.57L632.82 351.62V349.28C630.48 345.07 627.69 338.53 627.7 323.59L627.8 205.43ZM565.28 119.57C565.26 135.91 560.12 140.58 547.98 140.56H535.84L535.91 57.78H549.92C562.53 57.79 565.33 62.47 565.32 77.41L565.28 119.57Z", fill: "currentColor" }),
    /* @__PURE__ */ a.jsx("path", { d: "M731.56 124.7C716.16 107.41 712.43 96.19 712.45 79.85V71.91C712.46 60.23 715.27 53.2401 726.01 53.2401C737.22 53.25 739.54 60.26 739.54 71.47L739.5 114.91L799.28 114.96L799.32 68.26C799.36 22.49 781.16 0.0600484 732.59 0.0200484V4.84484e-05H719.99C676.56 -0.0399516 649.45 24.69 649.4 69.06V84C649.37 116.69 656.82 144.25 682.48 172.29L718.41 212.02C736.61 232.11 738.46 241.92 738.44 266.21V272.75C738.43 289.57 733.75 297.96 723.01 297.96C711.81 297.96 707.14 290.94 707.15 276.93L707.2 221.35L646.02 221.3L645.97 283.88C645.93 330.58 669.73 355.82 716.9 355.87H729.04C780.41 355.91 804.72 321.84 804.78 270V253.66C804.8 224.24 798.28 199.48 767.02 164.43L731.56 124.7Z", fill: "currentColor" }),
    /* @__PURE__ */ a.jsx("path", { d: "M975.32 72.41C975.35 29.91 964.17 3.74 911.39 3.7L823.12 3.63L822.83 351.1L884.95 351.15L885.07 211.97L914.49 212C957.92 212.04 975.22 184.5 975.26 142L975.32 72.41ZM912.69 135.87C912.68 146.61 910.8 155.48 896.79 155.46H885.13L885.21 57.4H896.88C910.89 57.41 912.74 65.82 912.74 77.96L912.69 135.87Z", fill: "currentColor" }),
    /* @__PURE__ */ a.jsx("path", { d: "M1012.05 3.79004L967.86 351.22L1022.97 351.27L1028.63 292.89L1065.99 292.92H1065.98L1072.47 351.31L1132.72 351.36L1085.84 3.85004L1012.05 3.79004ZM1034.75 233.12L1046.99 101.31L1059.97 233.14L1034.75 233.12Z", fill: "currentColor" }),
    /* @__PURE__ */ a.jsx("path", { d: "M1226.55 0.400057H1213.94C1158.83 0.360057 1140.58 37.2401 1140.55 79.2701L1140.39 275.42C1140.36 318.86 1153.87 357.63 1213.65 357.69H1226.26C1281.37 357.74 1298.22 318.99 1298.25 277.42L1298.32 203.96L1236.67 203.91H1236.66L1236.6 275.5C1236.59 288.11 1232.38 296.5 1221.17 296.5C1209.97 296.49 1205.3 289.02 1205.31 275.47L1205.47 79.3201C1205.48 65.7701 1209.23 59.2501 1220.9 59.2501C1232.57 59.2601 1236.76 66.2701 1236.76 79.3501L1236.71 140.7L1298.36 140.75L1298.41 77.0601C1298.44 37.3601 1285.86 0.460057 1226.55 0.400057Z", fill: "currentColor" }),
    /* @__PURE__ */ a.jsx("path", { d: "M1378.73 203.35L1431.97 203.4L1432.02 140.82L1378.78 140.77L1378.84 65.11L1449.57 65.17L1449.62 3.99H1449.64L1316.79 3.88L1316.5 351.35L1449.6 351.46L1449.65 288.88L1378.66 288.82L1378.73 203.35Z", fill: "currentColor" })
  ] }),
  /* @__PURE__ */ a.jsx("defs", { children: /* @__PURE__ */ a.jsx("clipPath", { id: "clip0_254_17087", children: /* @__PURE__ */ a.jsx("rect", { width: 1450, height: 358, fill: "white" }) }) })
] }), Qe = k.forwardRef(Je), qe = Qe, ne = ({
  altLogo: n,
  intl: i,
  urlPrefix: s,
  showLogoOnly: r = !1,
  analyticsTrackFunction: d,
  setShowSearchNav: l
}) => {
  const {
    formatComponentMessage: c
  } = y(b.NAVIGATION, i);
  return /* @__PURE__ */ a.jsxs(X, { className: "tw-h-[72px] tw-items-center tw-justify-between lg:tw-justify-start", children: [
    /* @__PURE__ */ a.jsx(L, { children: /* @__PURE__ */ a.jsx(z, { asChild: !0, children: /* @__PURE__ */ a.jsx("a", { href: s || "/", className: "hover:!tw-text-base-white", id: "header_link_home", onClick: (u) => d && d(u, "header_link_home"), children: n || /* @__PURE__ */ a.jsx(qe, { width: 146, height: 36, "aria-label": c(M.LOGO_ALT) }) }) }) }),
    !r && /* @__PURE__ */ a.jsx(L, { children: /* @__PURE__ */ a.jsx(j, { variant: "text-only", appearance: "white", prefix: /* @__PURE__ */ a.jsx(Re, {}), "aria-label": c(M.SEARCH), onClick: (u) => {
      l(!0), d && d(u, "header_link_search");
    }, id: "header_link_search", children: c(M.SEARCH) }) })
  ] });
}, he = ({
  children: n,
  content: i,
  onDismiss: s,
  open: r = !1,
  testId: d = "nav-item-tooltip"
}) => {
  const l = Pe(`(min-width: ${Be.LG}px)`);
  return /* @__PURE__ */ a.jsxs(be, { open: r && l, onOpenChange: (c) => !c && s?.(), children: [
    /* @__PURE__ */ a.jsx(je, { asChild: !0, children: n }),
    /* @__PURE__ */ a.jsxs(De, { align: "start", side: "bottom", className: "tw-relative tw-w-[280px] tw-bg-base-white tw-p-16", "data-testid": d, children: [
      /* @__PURE__ */ a.jsx(Me, { className: "tw-absolute tw-top-12 tw-right-12", children: /* @__PURE__ */ a.jsx(Ue, {}) }),
      /* @__PURE__ */ a.jsx(ye, { element: "p", typeface: "body-1", className: "tw-pr-16 tw-text-gray-900", children: i }),
      /* @__PURE__ */ a.jsx(He, { className: "tw-fill-base-white" })
    ] })
  ] });
}, ze = ({
  altLogo: n,
  avatarSrc: i,
  intl: s,
  messageCount: r,
  localeSelector: d,
  showLogoOnly: l,
  showReferral: c,
  urlPrefix: u,
  zendeskLocale: t,
  isVendor: S = !1,
  showListingsTooltip: f = !1,
  listingsTooltipContent: h,
  onDismissListingsTooltip: w,
  analyticsTrackFunction: A,
  logOutUser: I,
  setShowSearchNav: _
}) => /* @__PURE__ */ a.jsxs(ee, { variant: "black", className: "tw-flex tw-justify-between tw-gap-x-20", "data-testid": "logged-in-guest-navigation", children: [
  /* @__PURE__ */ a.jsx("div", { className: "tw-flex-grow", children: /* @__PURE__ */ a.jsx(ne, { altLogo: n, intl: s, urlPrefix: u, setShowSearchNav: _, showLogoOnly: l }) }),
  !l && /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsxs(X, { className: "tw-col-span-2 tw-items-center", children: [
    /* @__PURE__ */ a.jsx(L, { className: "tw-hidden lg:tw-block", "data-testid": "locale-selector", children: d }),
    Fe({
      intl: s,
      messageCount: r,
      urlPrefix: u,
      showReferral: c,
      zendeskLocale: t,
      isVendor: S,
      analyticsTrackFunction: A
    }).map((N) => {
      const x = /* @__PURE__ */ a.jsx(z, { href: N.url, id: N.id, onClick: (T) => N.onClick && N.onClick(T, N.id), children: N.display }), m = S && N.id === M.LISTINGS && !!h;
      return /* @__PURE__ */ a.jsxs(L, { className: F("tw-items-center tw-gap-x-8", N.className), children: [
        m ? /* @__PURE__ */ a.jsx(he, { open: f, onDismiss: w, content: h, testId: "listings-nav-tooltip", children: x }) : x,
        // make circle badge
        N.badge && /* @__PURE__ */ a.jsx("div", { className: N.badge.className, children: N.badge.display })
      ] }, N.id);
    }),
    /* @__PURE__ */ a.jsx(L, { className: "lg:tw-hidden", children: /* @__PURE__ */ a.jsx(Ee, { avatarSrc: i, localeSelector: d, navLinks: Ke({
      intl: s,
      messageCount: r,
      urlPrefix: u,
      logOutUser: I,
      showReferral: c,
      zendeskLocale: t,
      isVendor: S,
      analyticsTrackFunction: A
    }) }) }),
    /* @__PURE__ */ a.jsx(L, { className: "tw-hidden lg:tw-block", children: /* @__PURE__ */ a.jsx(Ne, { avatarSrc: i, navLinks: $e({
      intl: s,
      messageCount: r,
      urlPrefix: u,
      logOutUser: I,
      zendeskLocale: t,
      analyticsTrackFunction: A
    }) }) })
  ] }) })
] }), ea = ({
  addOnsBadge: n,
  altLogo: i,
  avatarSrc: s,
  intl: r,
  isVendor: d = !1,
  localeSelector: l,
  messageCount: c,
  myListingsBadge: u,
  showListingsTooltip: t = !1,
  listingsTooltipContent: S,
  onDismissListingsTooltip: f,
  showLogoOnly: h,
  showReferral: w,
  urlPrefix: A,
  zendeskLocale: I,
  analyticsTrackFunction: _,
  logOutUser: N,
  setShowSearchNav: x
}) => /* @__PURE__ */ a.jsxs(ee, { variant: "black", className: "tw-flex tw-justify-between tw-gap-x-20", "data-testid": "logged-in-host-navigation", children: [
  /* @__PURE__ */ a.jsx("div", { className: "tw-flex-grow", children: /* @__PURE__ */ a.jsx(ne, { altLogo: i, intl: r, urlPrefix: A, setShowSearchNav: x, showLogoOnly: h }) }),
  !h && /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsxs(X, { className: "tw-col-span-2 tw-items-center", children: [
    /* @__PURE__ */ a.jsx(L, { className: "tw-hidden lg:tw-block", "data-testid": "locale-selector", children: l }),
    Ze({
      addOnsBadge: n,
      intl: r,
      messageCount: c,
      myListingsBadge: u,
      urlPrefix: A,
      zendeskLocale: I,
      analyticsTrackFunction: _
    }).map((m) => {
      const T = /* @__PURE__ */ a.jsx(z, { href: m.url, id: m.id, onClick: (H) => m.onClick && m.onClick(H, m.id), children: m.display }), D = d && m.id === M.LISTINGS && !!S;
      return /* @__PURE__ */ a.jsxs(L, { className: F("tw-items-center tw-gap-x-8", m.className), children: [
        D ? /* @__PURE__ */ a.jsx(he, { open: t, onDismiss: f, content: S, testId: "listings-nav-tooltip", children: T }) : T,
        // make circle badge
        m.badge && /* @__PURE__ */ a.jsx("div", { className: m.badge.className, children: m.badge.display })
      ] }, m.id);
    }),
    /* @__PURE__ */ a.jsx(L, { className: "lg:tw-hidden", children: /* @__PURE__ */ a.jsx(Ee, { avatarSrc: s, localeSelector: l, navLinks: Xe({
      addOnsBadge: n,
      intl: r,
      messageCount: c,
      myListingsBadge: u,
      showReferral: w,
      urlPrefix: A,
      zendeskLocale: I,
      analyticsTrackFunction: _,
      logOutUser: N
    }) }) }),
    /* @__PURE__ */ a.jsx(L, { className: "tw-hidden lg:tw-block", children: /* @__PURE__ */ a.jsx(Ne, { avatarSrc: s, navLinks: ke({
      intl: r,
      analyticsTrackFunction: _,
      messageCount: c,
      urlPrefix: A,
      myListingsBadge: u,
      addOnsBadge: n,
      zendeskLocale: I,
      logOutUser: N,
      showReferral: w
    }) }) })
  ] }) })
] }), B = [{
  namespace: v.PHOTO_SHOOT,
  url: "/plan/photo-shoot",
  idSuffix: "photo_shoot"
}, {
  namespace: v.VIDEO_SHOOT,
  url: "/plan/video-shoot",
  idSuffix: "video_shoot"
}, {
  namespace: v.MEETING,
  url: "/plan/meeting",
  idSuffix: "meeting"
}, {
  namespace: v.PARTY,
  url: "/plan/party",
  idSuffix: "party"
}, {
  namespace: v.WORKSHOP,
  url: "/plan/workshop",
  idSuffix: "workshop"
}, {
  namespace: v.BABY_SHOWER,
  url: "/plan/baby-shower",
  idSuffix: "baby_shower"
}, {
  namespace: v.RETREAT,
  url: "/plan/retreat",
  idSuffix: "retreat"
}, {
  namespace: v.DINNER,
  url: "/plan/dinner",
  idSuffix: "dinner"
}, {
  namespace: v.TRAINING,
  url: "/plan/training",
  idSuffix: "training"
}, {
  namespace: v.WEDDING,
  url: "/plan/wedding",
  idSuffix: "wedding"
}, {
  namespace: v.BIRTHDAY_PARTY,
  url: "/plan/birthday-party",
  idSuffix: "birthday_party"
}, {
  namespace: v.BRIDAL_SHOWER,
  url: "/plan/bridal-shower",
  idSuffix: "bridal_shower"
}, {
  namespace: o.SEE_ALL,
  url: "/plan/activities",
  idSuffix: R.ACTIVITIES
}], U = [{
  namespace: g.KITCHEN,
  url: "/plan/kitchen",
  idSuffix: "kitchen"
}, {
  namespace: g.LOUNGE,
  url: "/plan/lounge",
  idSuffix: "lounge"
}, {
  namespace: g.CYCLORAMA,
  url: "/plan/cyclorama",
  idSuffix: "cyclorama"
}, {
  namespace: g.PIANO,
  url: "/plan/piano",
  idSuffix: "piano"
}, {
  namespace: g.POOL,
  url: "/plan/pool",
  idSuffix: "pool"
}, {
  namespace: g.BATHTUB,
  url: "/plan/bathtub",
  idSuffix: "bathtub"
}, {
  namespace: g.PATIO,
  url: "/plan/patio",
  idSuffix: "patio"
}, {
  namespace: g.GREEN_SCREEN,
  url: "/plan/green-screen",
  idSuffix: "green_screen"
}, {
  namespace: g.DECK,
  url: "/plan/deck",
  idSuffix: "deck"
}, {
  namespace: g.FIREPLACE,
  url: "/plan/fireplace",
  idSuffix: "fireplace"
}, {
  namespace: g.GRILL,
  url: "/plan/grill",
  idSuffix: "grill"
}, {
  namespace: g.FIRE_PIT,
  url: "/plan/fire-pit",
  idSuffix: "fire_pit"
}], P = [{
  namespace: O.PHOTOSHOOT_IDEAS,
  url: "/ideas/photo-shoot/all",
  idSuffix: "photoshoot_ideas"
}, {
  namespace: O.BABY_SHOWER_IDEAS,
  url: "/ideas/baby-shower/all",
  idSuffix: "baby_shower_ideas"
}, {
  namespace: O.PARTY_IDEAS,
  url: "/ideas/party/all",
  idSuffix: "party_ideas"
}, {
  namespace: O.BRIDAL_SHOWER_IDEAS,
  url: "/ideas/bridal-shower/all",
  idSuffix: "bridal_shower_ideas"
}, {
  namespace: O.BIRTHDAY_PHOTOSHOOT_IDEAS,
  url: "/ideas/birthday-photo-shoot/all",
  idSuffix: "birthday_photoshoot_ideas"
}, {
  namespace: O.BOUDOIR_PHOTOSHOOT_IDEAS,
  url: "/ideas/boudoir-photo-shoot/all",
  idSuffix: "boudoir_photoshoot_ideas"
}, {
  namespace: O.COUPLES_PHOTOSHOOT_IDEAS,
  url: "/ideas/couples-photo-shoot/all",
  idSuffix: "couples_photoshoot_ideas"
}, {
  namespace: O.SPRING_PHOTOSHOOT_IDEAS,
  url: "/ideas/spring-photo-shoot/all",
  idSuffix: "spring_photoshoot_ideas"
}, {
  namespace: O.OUTDOOR_PHOTOSHOOT_IDEAS,
  url: "/ideas/outdoor-photo-shoot/all",
  idSuffix: "outdoor_photoshoot_ideas"
}, {
  namespace: O.SUMMER_PHOTOSHOOT_IDEAS,
  url: "/ideas/summer-photo-shoot/all",
  idSuffix: "summer_photoshoot_ideas"
}, {
  namespace: O.BLACK_AND_WHITE_PHOTOSHOOT_IDEAS,
  url: "/ideas/black-and-white-photo-shoot/all",
  idSuffix: "black_and_white_photoshoot_ideas"
}, {
  namespace: O.PINK_PHOTOSHOOT_IDEAS,
  url: "/ideas/pink-photo-shoot/all",
  idSuffix: "pink_photoshoot_ideas"
}, {
  namespace: O.SEE_ALL,
  url: "/ideas/all",
  idSuffix: R.IDEAS
}], aa = (n) => {
  const {
    formatComponentMessage: i
  } = y(b.NAVBAR_BROWSE_PATHS_LOCATIONS, n);
  return {
    [e.ARCUEIL]: {
      display: i(e.ARCUEIL),
      url: "/fr/venues/fr/arcueil--île-de-france",
      id: "fr-fr_arcueil"
    },
    [e.ASNIERES_SUR_SEINE]: {
      display: i(e.ASNIERES_SUR_SEINE),
      url: "/fr/venues/fr/asnières-sur-seine--île-de-france",
      id: "fr-fr_asnières_sur_seine"
    },
    [e.ATLANTA]: {
      display: i(e.ATLANTA),
      url: "/venues/atlanta--ga",
      id: "en-us_atlanta"
    },
    [e.AUSTIN]: {
      display: i(e.AUSTIN),
      url: "/venues/austin--tx",
      id: "en-us_austin"
    },
    [e.BAGNOLET]: {
      display: i(e.BAGNOLET),
      url: "/fr/venues/fr/bagnolet--île-de-france",
      id: "fr-fr_bagnolet"
    },
    [e.BARCELONA]: {
      display: i(e.BARCELONA),
      url: "/de/venues/es/barcelona--ct",
      id: "es-es_barcelona"
    },
    [e.BERLIN]: {
      display: i(e.BERLIN),
      url: "/de/venues/de/berlin--be",
      id: "de-de_berlin"
    },
    [e.BOULOGNE_BILLANCOURT]: {
      display: i(e.BOULOGNE_BILLANCOURT),
      url: "/fr/venues/fr/boulogne-billancourt--île-de-france",
      id: "fr-fr_boulogne_billancourt"
    },
    [e.BRIGHTON_AND_HOVE]: {
      display: i(e.BRIGHTON_AND_HOVE),
      url: "/uk/venues/gb/brighton-and-hove--england",
      id: "en-gb_brighton_and_hove"
    },
    [e.BRISTOL]: {
      display: i(e.BRISTOL),
      url: "/uk/venues/gb/bristol-city--england",
      id: "en-gb_bristol"
    },
    [e.BROOKVALE]: {
      display: i(e.BROOKVALE),
      url: "/au/venues/au/brookvale--nsw",
      id: "en-au_brookvale"
    },
    [e.CALGARY]: {
      display: i(e.CALGARY),
      url: "/ca/venues/ca/calgary--ab",
      id: "en-ca_calgary"
    },
    [e.CHICAGO]: {
      display: i(e.CHICAGO),
      url: "/venues/chicago--il",
      id: "en-us_chicago"
    },
    [e.COLOMBES]: {
      display: i(e.COLOMBES),
      url: "/fr/venues/fr/colombes--île-de-france",
      id: "fr-fr_colombes"
    },
    [e.DALLAS]: {
      display: i(e.DALLAS),
      url: "/venues/dallas--tx",
      id: "en-us_dallas"
    },
    [e.EDINBURGH]: {
      display: i(e.EDINBURGH),
      url: "/uk/venues/gb/edinburgh--scotland",
      id: "en-gb_edinburgh"
    },
    [e.EDMONTON]: {
      display: i(e.EDMONTON),
      url: "/ca/venues/ca/edmonton--ab",
      id: "en-ca_edmonton"
    },
    [e.ESSEX]: {
      display: i(e.ESSEX),
      url: "/uk/venues/gb/essex--england",
      id: "en-gb_essex"
    },
    [e.FITZROY]: {
      display: i(e.FITZROY),
      url: "/au/venues/au/fitzroy--vic",
      id: "en-au_fitzroy"
    },
    [e.FORT_ERIE]: {
      display: i(e.FORT_ERIE),
      url: "/ca/venues/ca/fort-erie--on",
      id: "en-ca_fort_erie"
    },
    [e.GLASGOW]: {
      display: i(e.GLASGOW),
      url: "/uk/venues/gb/glasgow-city--scotland",
      id: "en-gb_glasgow"
    },
    [e.GLEBE]: {
      display: i(e.GLEBE),
      url: "/au/venues/au/glebe--nsw",
      id: "en-au_glebe"
    },
    [e.HOUSTON]: {
      display: i(e.HOUSTON),
      url: "/venues/houston--tx",
      id: "en-us_houston"
    },
    [e.ISSY_LES_MOULINEAUX]: {
      display: i(e.ISSY_LES_MOULINEAUX),
      url: "/fr/venues/fr/issy-les-moulineaux--île-de-france",
      id: "fr-fr_issy_les_moulineaux"
    },
    [e.IVRY_SUR_SEINE]: {
      display: i(e.IVRY_SUR_SEINE),
      url: "/fr/venues/fr/ivry-sur-seine--île-de-france",
      id: "fr-fr_ivry_sur_seine"
    },
    [e.LEICESTER]: {
      display: i(e.LEICESTER),
      url: "/uk/venues/gb/leicester--england",
      id: "en-gb_leicester"
    },
    [e.LONDON]: {
      display: i(e.LONDON),
      url: "/uk/venues/gb/greater-london--england",
      id: "en-gb_london"
    },
    [e.LOS_ANGELES]: {
      display: i(e.LOS_ANGELES),
      url: "/venues/los-angeles--ca",
      id: "en-us_los_angeles"
    },
    [e.MALAKOFF]: {
      display: i(e.MALAKOFF),
      url: "/fr/venues/fr/malakoff--île-de-france",
      id: "fr-fr_malakoff"
    },
    [e.MANCHESTER]: {
      display: i(e.MANCHESTER),
      url: "/uk/venues/gb/greater-manchester--england",
      id: "en-gb_manchester"
    },
    [e.MELBOURNE]: {
      display: i(e.MELBOURNE),
      url: "/au/venues/au/melbourne--vic",
      id: "en-au_melbourne"
    },
    [e.MISSISSAUGA]: {
      display: i(e.MISSISSAUGA),
      url: "/ca/venues/ca/mississauga--on",
      id: "en-ca_mississauga"
    },
    [e.MONTREUIL]: {
      display: i(e.MONTREUIL),
      url: "/fr/venues/fr/montreuil--île-de-france",
      id: "fr-fr_montreuil"
    },
    [e.NEUILLY_SUR_SEINE]: {
      display: i(e.NEUILLY_SUR_SEINE),
      url: "/fr/venues/fr/neuilly-sur-seine--île-de-france",
      id: "fr-fr_neuilly_sur_seine"
    },
    [e.NEW_YORK]: {
      display: i(e.NEW_YORK),
      url: "/venues/new-york--ny",
      id: "en-us_new_york"
    },
    [e.NEWTOWN]: {
      display: i(e.NEWTOWN),
      url: "/ca/venues/ca/newtown--nsw",
      id: "en-ca_newtown"
    },
    [e.NORTH_SYDNEY]: {
      display: i(e.NORTH_SYDNEY),
      url: "/au/venues/au/north-sydney--nsw",
      id: "en-au_north_sydney"
    },
    [e.NORTH_VANCOUVER]: {
      display: i(e.NORTH_VANCOUVER),
      url: "/ca/venues/ca/north-vancouver--bc",
      id: "en-ca_north_vancouver"
    },
    [e.NOTTINGHAM]: {
      display: i(e.NOTTINGHAM),
      url: "/uk/venues/gb/nottingham--england",
      id: "en-gb_nottingham"
    },
    [e.PADDINGTON]: {
      display: i(e.PADDINGTON),
      url: "/au/venues/au/paddington--nsw",
      id: "en-au_paddington"
    },
    [e.PANTIN]: {
      display: i(e.PANTIN),
      url: "/fr/venues/fr/pantin--île-de-france",
      id: "fr-fr_pantin"
    },
    [e.PARIS]: {
      display: i(e.PARIS),
      url: "/fr/venues/fr/paris--île-de-france",
      id: "fr-fr_paris"
    },
    [e.PHILADELPHIA]: {
      display: i(e.PHILADELPHIA),
      url: "/venues/philadelphia--pa",
      id: "en-us_philadelphia"
    },
    [e.RICHMOND]: {
      display: i(e.RICHMOND),
      url: "/ca/venues/ca/richmond--vic",
      id: "en-ca_richmond"
    },
    [e.RICHMOND_HILL]: {
      display: i(e.RICHMOND_HILL),
      url: "/ca/venues/ca/richmond-hill--on",
      id: "en-ca_richmond_hill"
    },
    [e.SAINT_MAUR_DES_FOSSES]: {
      display: i(e.SAINT_MAUR_DES_FOSSES),
      url: "/fr/venues/fr/saint-maur-des-fossés--île-de-france",
      id: "fr-fr_saint_maur_des_fossés"
    },
    [e.SAINT_OUEN]: {
      display: i(e.SAINT_OUEN),
      url: "/fr/venues/fr/saint-ouen--île-de-france",
      id: "fr-fr_saint_ouen"
    },
    [e.SAN_DIEGO]: {
      display: i(e.SAN_DIEGO),
      url: "/venues/san-diego--ca",
      id: "en-us_san_diego"
    },
    [e.SAN_FRANCISCO]: {
      display: i(e.SAN_FRANCISCO),
      url: "/venues/san-francisco--ca",
      id: "en-us_san_francisco"
    },
    [e.SEATTLE]: {
      display: i(e.SEATTLE),
      url: "/venues/seattle--wa",
      id: "en-us_seattle"
    },
    [e.SOUTH_MELBOURNE]: {
      display: i(e.SOUTH_MELBOURNE),
      url: "/au/venues/au/south-melbourne--vic",
      id: "en-au_south_melbourne"
    },
    [e.ST_KILDA]: {
      display: i(e.ST_KILDA),
      url: "/au/venues/au/st-kilda--vic",
      id: "en-au_st_kilda"
    },
    [e.SURREY]: {
      display: i(e.SURREY),
      url: "/uk/venues/gb/surrey--england",
      id: "en-gb_surrey"
    },
    [e.SYDNEY]: {
      display: i(e.SYDNEY),
      url: "/au/venues/au/sydney--nsw",
      id: "en-au_sydney"
    },
    [e.TORONTO]: {
      display: i(e.TORONTO),
      url: "/ca/venues/ca/toronto--on",
      id: "en-ca_toronto"
    },
    [e.VANCOUVER]: {
      display: i(e.VANCOUVER),
      url: "/ca/venues/ca/vancouver--bc",
      id: "en-ca_vancouver"
    },
    [e.VAUGHAN]: {
      display: i(e.VAUGHAN),
      url: "/ca/venues/ca/vaughan--on",
      id: "en-ca_vaughan"
    },
    [e.VITRY_SUR_SEINE]: {
      display: i(e.VITRY_SUR_SEINE),
      url: "/fr/venues/fr/vitry-sur-seine--île-de-france",
      id: "fr-fr_vitry_sur_seine"
    },
    [e.WASHINGTON_DC]: {
      display: i(e.WASHINGTON_DC),
      url: "/venues/washington--dc",
      id: "en-us_washington_dc"
    },
    [e.WEST_MIDLANDS]: {
      display: i(e.WEST_MIDLANDS),
      url: "/uk/venues/gb/west-midlands--england",
      id: "en-gb_west_midlands"
    }
  };
}, G = [{
  namespace: C.HOUSE,
  url: "/plan/house",
  idSuffix: "house"
}, {
  namespace: C.BAR,
  url: "/plan/bar",
  idSuffix: "bar"
}, {
  namespace: C.GARAGE,
  url: "/plan/garage",
  idSuffix: "garage"
}, {
  namespace: C.WAREHOUSE,
  url: "/plan/warehouse",
  idSuffix: "warehouse"
}, {
  namespace: C.CABIN,
  url: "/plan/cabin",
  idSuffix: "cabin"
}, {
  namespace: C.MOVIE_THEATER,
  url: "/plan/movie-theater",
  idSuffix: "movie_theater"
}, {
  namespace: C.MANSION,
  url: "/plan/mansion",
  idSuffix: "mansion"
}, {
  namespace: C.COMMUNITY_CENTER,
  url: "/plan/community-center",
  idSuffix: "community_center"
}, {
  namespace: C.CASTLE,
  url: "/plan/castle",
  idSuffix: "castle"
}, {
  namespace: C.BASKETBALL_COURT,
  url: "/plan/basketball-court",
  idSuffix: "basketball_court"
}, {
  namespace: C.COMMERCIAL_KITCHEN,
  url: "/plan/commercial-kitchen",
  idSuffix: "commercial_kitchen"
}, {
  namespace: C.BARN,
  url: "/plan/barn",
  idSuffix: "barn"
}], sa = [{
  namespace: Z.CATERERS_AND_PRIVATE_CHEFS,
  url: "/vendors/chicago--il/caterers-and-private-chefs",
  idSuffix: "caterers_and_private_chefs"
}, {
  namespace: Z.PHOTOGRAPHERS,
  url: "/vendors/chicago--il/photographers",
  idSuffix: "photographers"
}, {
  namespace: Z.LIVE_MUSICIANS_AND_DJS,
  url: "/vendors/chicago--il/live-musicians-and-djs",
  idSuffix: "live_musicians_and_djs"
}, {
  namespace: Z.BAR_SERVICES_AND_BEVERAGES,
  url: "/vendors/chicago--il/bar-services-and-beverages",
  idSuffix: "bar_services_and_beverages"
}, {
  namespace: Z.SEE_ALL,
  url: "/vendors/chicago--il",
  idSuffix: R.VENDORS
}], E = (n, i, s) => n.map((r) => ({
  display: i(r.namespace),
  url: r.url,
  id: `${s}_${r.idSuffix}`
})), ia = (n, i) => {
  const {
    formatComponentMessage: s
  } = y(b.NAVBAR_BROWSE_PATHS, n), {
    formatComponentMessage: r
  } = y(b.NAVBAR_BROWSE_PATHS_ACTIVITIES, n), {
    formatComponentMessage: d
  } = y(b.NAVBAR_BROWSE_PATHS_SPACE_TYPES, n), {
    formatComponentMessage: l
  } = y(b.NAVBAR_BROWSE_PATHS_IDEAS, n), {
    formatComponentMessage: c
  } = y(b.NAVBAR_BROWSE_PATHS_AMENITIES, n), {
    formatComponentMessage: u
  } = y(b.NAVBAR_BROWSE_PATHS_VENDORS, n), t = aa(n);
  return {
    [p.EN_US]: {
      locations: {
        display: s(o.LOCATIONS),
        id: "en-us_locations",
        children: [t[e.LOS_ANGELES], t[e.NEW_YORK], t[e.CHICAGO], t[e.ATLANTA], t[e.SAN_FRANCISCO], t[e.SEATTLE], t[e.HOUSTON], t[e.DALLAS], t[e.AUSTIN], t[e.PHILADELPHIA], t[e.SAN_DIEGO], t[e.WASHINGTON_DC], {
          display: s(o.SEE_ALL),
          url: "/venues/locations",
          id: `en-us_${R.LOCATIONS}`
        }]
      },
      activities: {
        display: s(o.ACTIVITIES),
        id: "en-us_activities",
        children: E(B, r, p.EN_US)
      },
      spaceTypes: {
        display: s(o.SPACE_TYPES),
        id: "en-us_space_types",
        children: E(G, d, p.EN_US)
      },
      amenities: {
        display: s(o.AMENITIES),
        id: "en-us_amenities",
        children: E(U, c, p.EN_US)
      },
      ideas: {
        display: s(o.IDEAS),
        id: "en-us_ideas",
        children: E(P, l, p.EN_US)
      },
      vendors: {
        display: s(o.VENDORS),
        id: "en-us_vendors",
        children: E(sa, u, p.EN_US)
      }
    },
    /**
     ***************************************************
     * FRANCE
     *******************************
     */
    [p.FR_FR]: {
      locations: {
        display: s(o.LOCATIONS),
        id: "fr-fr_locations",
        children: [t[e.PARIS], t[e.BOULOGNE_BILLANCOURT], t[e.MONTREUIL], t[e.IVRY_SUR_SEINE], t[e.ARCUEIL], t[e.ASNIERES_SUR_SEINE], t[e.SAINT_MAUR_DES_FOSSES], t[e.PANTIN], t[e.NEUILLY_SUR_SEINE], t[e.BAGNOLET], t[e.MALAKOFF], t[e.COLOMBES], t[e.SAINT_OUEN], t[e.ISSY_LES_MOULINEAUX], t[e.VITRY_SUR_SEINE], {
          display: s(o.SEE_ALL),
          url: "/fr/venues/locations",
          id: `fr-fr_${R.LOCATIONS}`
        }]
      },
      activities: {
        display: s(o.ACTIVITIES),
        id: "fr-fr_activities",
        children: E(B, r, p.FR_FR)
      },
      spaceTypes: {
        display: s(o.SPACE_TYPES),
        id: "fr-fr_space_types",
        children: E(G, d, p.FR_FR)
      },
      amenities: {
        display: s(o.AMENITIES),
        id: "fr-fr_amenities",
        children: E(U, c, p.FR_FR)
      },
      ideas: {
        display: s(o.IDEAS),
        id: "fr-fr_ideas",
        children: E(P, l, p.FR_FR)
      },
      vendors: {
        display: s(o.VENDORS),
        id: "fr-fr_vendors",
        children: []
      }
    },
    /**
     ***************************************************
     * UNITED KINGDOM
     *******************************
     */
    [p.EN_GB]: {
      locations: {
        display: s(o.LOCATIONS),
        id: "en-gb_locations",
        children: [t[e.LONDON], t[e.MANCHESTER], t[e.SURREY], t[e.GLASGOW], t[e.EDINBURGH], t[e.BRISTOL], t[e.BRIGHTON_AND_HOVE], t[e.NOTTINGHAM], t[e.LEICESTER], t[e.ESSEX], t[e.WEST_MIDLANDS], {
          display: s(o.SEE_ALL),
          url: "/uk/venues/locations",
          id: `en-gb_${R.LOCATIONS}`
        }]
      },
      activities: {
        display: s(o.ACTIVITIES),
        id: "en-gb_activities",
        children: E(B, r, p.EN_GB)
      },
      spaceTypes: {
        display: s(o.SPACE_TYPES),
        id: "en-gb_space_types",
        children: E(G, d, p.EN_GB)
      },
      amenities: {
        display: s(o.AMENITIES),
        id: "en-gb_amenities",
        children: E(U, c, p.EN_GB)
      },
      ideas: {
        display: s(o.IDEAS),
        id: "en-gb_ideas",
        children: E(P, l, p.EN_GB)
      },
      vendors: {
        display: s(o.VENDORS),
        id: "en-gb_vendors",
        children: []
      }
    },
    /**
     ***************************************************
     * CANADA
     *******************************
     */
    [p.EN_CA]: {
      locations: {
        display: s(o.LOCATIONS),
        id: "en-ca_locations",
        children: [t[e.TORONTO], t[e.VANCOUVER], t[e.NORTH_VANCOUVER], t[e.CALGARY], t[e.EDMONTON], t[e.FORT_ERIE], t[e.MISSISSAUGA], t[e.RICHMOND_HILL], t[e.SURREY], t[e.VAUGHAN], t[e.VANCOUVER], {
          display: s(o.SEE_ALL),
          url: "/ca/venues/locations",
          id: `en-ca_${R.LOCATIONS}`
        }]
      },
      activities: {
        display: s(o.ACTIVITIES),
        id: "en-ca_activities",
        children: E(B, r, p.EN_CA)
      },
      spaceTypes: {
        display: s(o.SPACE_TYPES),
        id: "en-ca_space_types",
        children: E(G, d, p.EN_CA)
      },
      amenities: {
        display: s(o.AMENITIES),
        id: "en-ca_amenities",
        children: E(U, c, p.EN_CA)
      },
      ideas: {
        display: s(o.IDEAS),
        id: "en-ca_ideas",
        children: E(P, l, p.EN_CA)
      },
      vendors: {
        display: s(o.VENDORS),
        id: "en-ca_vendors",
        children: []
      }
    },
    /**
     ***************************************************
     * AUSTRALIA
     *******************************
     */
    [p.EN_AU]: {
      locations: {
        display: s(o.LOCATIONS),
        id: "en-au_locations",
        children: [t[e.SYDNEY], t[e.MELBOURNE], t[e.BROOKVALE], t[e.NORTH_SYDNEY], t[e.SOUTH_MELBOURNE], t[e.NEWTOWN], t[e.PADDINGTON], t[e.FITZROY], t[e.GLEBE], t[e.ST_KILDA], t[e.RICHMOND], {
          display: s(o.SEE_ALL),
          url: "/au/venues/locations",
          id: `en-au_${R.LOCATIONS}`
        }]
      },
      activities: {
        display: s(o.ACTIVITIES),
        id: "en-au_activities",
        children: E(B, r, p.EN_AU)
      },
      spaceTypes: {
        display: s(o.SPACE_TYPES),
        id: "en-au_space_types",
        children: E(G, d, p.EN_AU)
      },
      amenities: {
        display: s(o.AMENITIES),
        id: "en-au_amenities",
        children: E(U, c, p.EN_AU)
      },
      ideas: {
        display: s(o.IDEAS),
        id: "en-au_ideas",
        children: E(P, l, p.EN_AU)
      },
      vendors: {
        display: s(o.VENDORS),
        id: "en-au_vendors",
        children: []
      }
    },
    /**
     ***************************************************
     * GERMANY
     *******************************
     */
    [p.DE_DE]: {
      locations: {
        display: s(o.LOCATIONS),
        id: "de-de_locations",
        children: [t[e.BERLIN], {
          display: s(o.SEE_ALL),
          url: "/de/venues/locations",
          id: `de-de_${R.LOCATIONS}`
        }]
      },
      activities: {
        display: s(o.ACTIVITIES),
        id: "de-de_activities",
        children: E(B, r, p.DE_DE)
      },
      spaceTypes: {
        display: s(o.SPACE_TYPES),
        id: "de-de_space_types",
        children: E(G, d, p.DE_DE)
      },
      amenities: {
        display: s(o.AMENITIES),
        id: "de-de_amenities",
        children: E(U, c, p.DE_DE)
      },
      ideas: {
        display: s(o.IDEAS),
        id: "de-de_ideas",
        children: E(P, l, p.DE_DE)
      },
      vendors: {
        display: s(o.VENDORS),
        id: "de-de_vendors",
        children: []
      }
    },
    /**
     ***************************************************
     * SPAIN
     *******************************
     */
    [p.ES_ES]: {
      locations: {
        display: s(o.LOCATIONS),
        id: "es-es_locations",
        children: [t[e.BARCELONA], {
          display: s(o.SEE_ALL),
          url: "/es/venues/locations",
          id: `es-es_${R.LOCATIONS}`
        }]
      },
      activities: {
        display: s(o.ACTIVITIES),
        id: "es-es_activities",
        children: E(B, r, p.ES_ES)
      },
      spaceTypes: {
        display: s(o.SPACE_TYPES),
        id: "es-es_space_types",
        children: E(G, d, p.ES_ES)
      },
      amenities: {
        display: s(o.AMENITIES),
        id: "es-es_amenities",
        children: E(U, c, p.ES_ES)
      },
      ideas: {
        display: s(o.IDEAS),
        id: "es-es_ideas",
        children: E(P, l, p.ES_ES)
      },
      vendors: {
        display: s(o.VENDORS),
        id: "es-es_vendors",
        children: []
      }
    }
  }[i || p.EN_US];
}, ta = (n, i) => /* @__PURE__ */ a.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref: i, ...n, children: /* @__PURE__ */ a.jsx("path", { fill: "currentColor", d: "M8.72 4.22a.75.75 0 0 1 1.06 0l7.25 7.25a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06-1.06L15.44 12 8.72 5.28a.75.75 0 0 1 0-1.06Z" }) }), na = k.forwardRef(ta), fe = (n) => n.includes(R.SEE_ALL), ra = ({
  browseCategories: n,
  intl: i,
  urlPrefix: s
}) => {
  const {
    formatComponentMessage: r
  } = y(b.NAVIGATION, i), d = (l) => n[l].children.map((u) => /* @__PURE__ */ a.jsx(Se, { asChild: !0, "data-test-id": `dropdown-menu-item-${u.id}`, children: /* @__PURE__ */ a.jsx(j, { href: u.url.startsWith(s ?? "") ? u.url : `${s ?? ""}${u.url}`, variant: "text-only", appearance: fe(u.id) ? "purple" : "white", className: "tw-text-left tw-justify-start tw-text-wrap", children: u.display }) }, u.id));
  return /* @__PURE__ */ a.jsxs(ce, { children: [
    /* @__PURE__ */ a.jsx(ue, { asChild: !0, children: /* @__PURE__ */ a.jsx(j, { variant: "text-only", appearance: "white", suffix: /* @__PURE__ */ a.jsx(oe, {}), "data-testid": `${M.BROWSE_SPACES_NAV_ITEM}_BUTTON`, children: r(M.BROWSE_SPACES_NAV_ITEM) }) }),
    /* @__PURE__ */ a.jsx(pe, { side: "bottom", align: "start", className: "tw-w-[200px]", children: /* @__PURE__ */ a.jsx(_e, { children: Object.keys(n).map((l) => n[l].children.length > 0 && /* @__PURE__ */ a.jsxs(Te, { children: [
      /* @__PURE__ */ a.jsx(ve, { "data-testid": `${l}`, children: n[l].display }),
      /* @__PURE__ */ a.jsx(ge, { children: /* @__PURE__ */ a.jsx(Ce, { className: "tw-w-[200px]", children: d(l) }) })
    ] }, l)) }) })
  ] });
}, we = ({
  browseCategories: n,
  intl: i,
  pathname: s = "",
  shouldSendAuthToPage: r = !0,
  urlPrefix: d = "",
  analyticsTrackFunction: l
}) => {
  const {
    formatComponentMessage: c
  } = y(b.NAVIGATION, i), {
    BROWSE_SPACES_NAV_ITEM: u,
    LIST_SPACE: t,
    LOGIN: S,
    SIGNUP: f
  } = M, h = s ? `&dest=${encodeURIComponent(s)}` : "", w = r ? `${d}/signin?source=log${h}` : "#a=login", A = r ? `${d}/signup?source=nav${h}` : "#a=signup&source=nav";
  return {
    [u]: {
      id: u,
      dataTestId: u,
      display: c(u),
      className: "tw-hidden lg:tw-block",
      children: /* @__PURE__ */ a.jsx(ra, { browseCategories: n, intl: i, urlPrefix: d, "data-testid": `${u}_BUTTON` })
    },
    [t]: {
      id: "header_link_add_space",
      dataTestId: t,
      display: c(t),
      url: `${d}/host`,
      variant: "text-only",
      appearance: "white",
      className: "tw-hidden lg:tw-block",
      onClick: l
    },
    [S]: {
      id: "header_link_signin",
      dataTestId: S,
      display: c(S),
      url: w,
      variant: "text-only",
      appearance: "white",
      className: "tw-hidden lg:tw-block",
      onClick: l
    },
    [f]: {
      id: "header_link_signup",
      dataTestId: f,
      display: c(f),
      url: A,
      variant: "default",
      appearance: "white",
      className: "tw-hidden lg:tw-block",
      onClick: l
    }
  };
}, da = (n) => {
  const {
    BROWSE_SPACES_NAV_ITEM: i,
    LIST_SPACE: s,
    LOGIN: r,
    SIGNUP: d
  } = we(n);
  return [i, s, r, d];
}, la = (n) => {
  const {
    BROWSE_SPACES_NAV_ITEM: i,
    LIST_SPACE: s,
    LOGIN: r,
    SIGNUP: d
  } = we(n);
  return [{
    ...i,
    className: "tw-flex [&>span]:tw-flex [&>span]:tw-justify-between [&>span]:tw-flex-1",
    children: null,
    suffix: /* @__PURE__ */ a.jsx(na, {}),
    onClick: () => n.setCurrentDrawerContent?.(W.BROWSE)
  }, {
    ...s,
    className: "tw-flex"
  }, {
    ...r,
    className: "tw-flex"
  }, {
    ...d,
    className: "tw-flex"
  }];
}, oa = (n, i) => /* @__PURE__ */ a.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref: i, ...n, children: /* @__PURE__ */ a.jsx("path", { fill: "currentColor", d: "M21 5.75a.75.75 0 0 1-.75.75H3.75a.75.75 0 0 1 0-1.5h16.5a.75.75 0 0 1 .75.75Zm0 6a.75.75 0 0 1-.75.75H3.75a.75.75 0 0 1 0-1.5h16.5a.75.75 0 0 1 .75.75Zm-.75 6.75a.75.75 0 0 0 0-1.5H3.75a.75.75 0 0 0 0 1.5h16.5Z" }) }), ca = k.forwardRef(oa), ua = (n, i) => /* @__PURE__ */ a.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref: i, ...n, children: /* @__PURE__ */ a.jsx("path", { fill: "currentColor", d: "M4.22 8.72a.75.75 0 0 1 1.06 0L12 15.44l6.72-6.72a.75.75 0 1 1 1.06 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L4.22 9.78a.75.75 0 0 1 0-1.06Z" }) }), pa = k.forwardRef(ua), _a = (n, i) => /* @__PURE__ */ a.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref: i, ...n, children: /* @__PURE__ */ a.jsx("path", { fill: "currentColor", d: "M15.28 4.22a.75.75 0 0 1 0 1.06L8.56 12l6.72 6.72a.75.75 0 1 1-1.06 1.06l-7.25-7.25a.75.75 0 0 1 0-1.06l7.25-7.25a.75.75 0 0 1 1.06 0Z" }) }), Sa = k.forwardRef(_a), Ea = ({
  handleBackClick: n,
  browseCategories: i
}) => /* @__PURE__ */ a.jsxs("div", { children: [
  /* @__PURE__ */ a.jsx(ae, { className: "tw-text-left tw-p-24 tw-border-b tw-border-gray-700", children: /* @__PURE__ */ a.jsxs("div", { className: "tw-flex tw-items-center tw-justify-between", children: [
    /* @__PURE__ */ a.jsx(j, { variant: "text-only", appearance: "white", onClick: n, "aria-label": "Back to main menu", children: /* @__PURE__ */ a.jsx(Sa, {}) }),
    /* @__PURE__ */ a.jsx(se, { children: /* @__PURE__ */ a.jsx(ie, { className: "tw-text-base-white" }) })
  ] }) }),
  /* @__PURE__ */ a.jsx("div", { className: "tw-p-24 tw-flex tw-flex-col tw-flex-1 tw-gap-y-32 tw-overflow-y-auto tw-max-h-[calc(100vh-100px)] tw-animate-in tw-slide-in-from-left-72", children: /* @__PURE__ */ a.jsx(Ge, { type: "single", collapsible: !0, children: Object.keys(i).map((s) => i[s].children.length > 0 && /* @__PURE__ */ a.jsxs(Ve, { value: s, showDivider: !1, "data-test-id": `${s}-accordion-item`, children: [
    /* @__PURE__ */ a.jsx(Ye, { className: "tw-text-left tw-w-full tw-justify-between tw-text-wrap tw-headline-2-m tw-pb-24 tw-pt-0 hover:tw-no-underline tw-text-base-white", triggerIcon: /* @__PURE__ */ a.jsx(pa, {}), children: i[s].display }),
    /* @__PURE__ */ a.jsx(We, { children: /* @__PURE__ */ a.jsx("div", { className: "tw-flex tw-flex-col tw-gap-y-24", children: i[s].children.map((r) => /* @__PURE__ */ a.jsx(j, { href: r.url, variant: "text-only", appearance: fe(r.id) ? "purple" : "white", className: "tw-text-left tw-justify-start", children: r.display }, r.display)) }) })
  ] }, s)) }) })
] }), Na = ({
  localeSelector: n,
  navLinks: i
}) => /* @__PURE__ */ a.jsxs("div", { children: [
  /* @__PURE__ */ a.jsx(ae, { className: "tw-text-left tw-p-24 tw-border-b tw-border-gray-700", children: /* @__PURE__ */ a.jsxs("div", { className: "tw-flex tw-items-center tw-justify-between [&>button]:tw-text-base-white [&>button]:hover:tw-text-gray-500 [&_svg]:tw-w-24 [&_svg]:tw-h-24", children: [
    n,
    /* @__PURE__ */ a.jsx(se, { children: /* @__PURE__ */ a.jsx(ie, { className: "tw-text-base-white" }) })
  ] }) }),
  /* @__PURE__ */ a.jsx("div", { className: "tw-p-24 tw-flex tw-flex-col tw-gap-y-32 tw-overflow-y-auto tw-max-h-[calc(100vh-100px)] tw-animate-in tw-slide-in-from-left-72", children: i.map((s) => /* @__PURE__ */ a.jsxs(J.Fragment, { "data-test-id": s.dataTestId, children: [
    /* @__PURE__ */ a.jsx(j, { ...s.onClick && {
      onClick: (r) => s.onClick(r, s.id || "")
    }, ...s.url && {
      href: s.url
    }, ...s.suffix && {
      suffix: s.suffix
    }, ...s.id && {
      id: s.id
    }, variant: "text-only", appearance: "white", className: F("tw-text-left tw-justify-start tw-text-wrap tw-headline-2-m", s.className), children: s.display }),
    s.divider && /* @__PURE__ */ a.jsx("hr", { className: "tw-border-gray-400" })
  ] }, s.id)) })
] }), ha = ({
  localeSelector: n,
  navLinks: i,
  browseCategories: s,
  currentDrawer: r,
  setCurrentDrawerContent: d
}) => {
  const [l, c] = q(!1), u = () => {
    d(W.BROWSE);
  }, t = () => {
    d(W.MAIN);
  };
  return /* @__PURE__ */ a.jsxs(re, { activeSnapPoint: 1, open: l, onOpenChange: (S) => {
    c(S), S || d(W.MAIN);
  }, children: [
    /* @__PURE__ */ a.jsx(de, { asChild: !0, children: /* @__PURE__ */ a.jsx(j, { variant: "text-only", appearance: "white", iconOnly: !0, children: /* @__PURE__ */ a.jsx(ca, {}) }) }),
    /* @__PURE__ */ a.jsx(le, { "data-testid": "content", className: "tw-h-full tw-max-h-[97%] tw-mx-[-1px] tw-bg-base-black", children: r === W.MAIN ? /* @__PURE__ */ a.jsx(Na, { localeSelector: n, navLinks: i, handleBrowseClick: u }) : /* @__PURE__ */ a.jsx(Ea, { handleBackClick: t, browseCategories: s }) })
  ] });
}, fa = ({
  altLogo: n,
  intl: i,
  localeSelector: s,
  locale: r,
  shouldSendAuthToPage: d = !0,
  showLogoOnly: l = !1,
  urlPrefix: c,
  setShowSearchNav: u,
  analyticsTrackFunction: t
}) => {
  const S = ia(i, r), [f, h] = q(W.MAIN), [w, A] = q("");
  me(() => {
    if (typeof window < "u") {
      const {
        pathname: _,
        search: N,
        hash: x
      } = window.location;
      A(`${_}${N}${x}`);
    }
  });
  const I = l || w.includes("/signup") || w.includes("/signin");
  return /* @__PURE__ */ a.jsxs(ee, { variant: "black", className: "tw-flex tw-justify-between tw-gap-x-20", "data-testid": "logged-out-navigation", children: [
    /* @__PURE__ */ a.jsx("div", { className: "tw-flex-grow", children: /* @__PURE__ */ a.jsx(ne, { altLogo: n, intl: i, urlPrefix: c, setShowSearchNav: u, showLogoOnly: I }) }),
    !I && /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsxs(X, { className: "tw-col-span-2 tw-items-center", children: [
      /* @__PURE__ */ a.jsx(L, { className: "tw-hidden lg:tw-flex", "data-testid": "locale-selector", children: s }),
      da({
        browseCategories: S,
        intl: i,
        pathname: w,
        shouldSendAuthToPage: d,
        urlPrefix: c,
        analyticsTrackFunction: t
      }).map((_) => /* @__PURE__ */ a.jsx(L, { className: _.className, "data-testid": _.dataTestId, children: J.isValidElement(_.children) ? _.children : /* @__PURE__ */ a.jsx(j, { ..._.url && {
        href: _.url
      }, ..._.variant && {
        variant: _.variant
      }, ..._.appearance && {
        appearance: _.appearance
      }, ..._.id && {
        id: _.id
      }, ..._.onClick && {
        onClick: (N) => _.onClick(N, _.id || "")
      }, children: _.display }) }, _.display)),
      /* @__PURE__ */ a.jsx(L, { className: "tw-block lg:tw-hidden", children: /* @__PURE__ */ a.jsx(ha, { localeSelector: s, navLinks: la({
        intl: i,
        urlPrefix: c,
        browseCategories: S,
        pathname: w,
        shouldSendAuthToPage: d,
        setCurrentDrawerContent: h,
        analyticsTrackFunction: t
      }), browseCategories: S, currentDrawer: f, setCurrentDrawerContent: h }) })
    ] }) })
  ] });
}, Ua = ({
  altLogo: n,
  intl: i,
  profile: s,
  locale: r,
  localeSelector: d,
  messageCount: l,
  nuxData: c,
  showLogoOnly: u = !1,
  shouldSendAuthToPage: t = !0,
  urlPrefix: S,
  zendeskLocale: f,
  showListingsTooltip: h,
  listingsTooltipContent: w,
  onDismissListingsTooltip: A,
  analyticsTrackFunction: I,
  logOutUser: _,
  setShowSearchNav: N
}) => {
  const x = !!s?.isHost, m = !!s?.isVendor, T = !!s?.SSOId, D = s?.avatarUrl, H = !!c?.find((Q) => Q.name === "mylistings-new-badge"), V = !!c?.find((Q) => Q.name === "addons-new-badge"), Y = !(p.EN_US !== String(i.locale || "en-US"));
  return T && x ? /* @__PURE__ */ a.jsx(ea, { addOnsBadge: V, altLogo: n, avatarSrc: D, intl: i, localeSelector: d, messageCount: l, myListingsBadge: H, isVendor: m, showLogoOnly: u, showReferral: Y, urlPrefix: S, zendeskLocale: f, showListingsTooltip: h, listingsTooltipContent: w, onDismissListingsTooltip: A, analyticsTrackFunction: I, logOutUser: _, setShowSearchNav: N }) : T ? /* @__PURE__ */ a.jsx(ze, { altLogo: n, avatarSrc: D, intl: i, localeSelector: d, messageCount: l, showLogoOnly: u, showReferral: Y, urlPrefix: S, zendeskLocale: f, analyticsTrackFunction: I, logOutUser: _, setShowSearchNav: N, isVendor: m, showListingsTooltip: h, listingsTooltipContent: w, onDismissListingsTooltip: A }) : /* @__PURE__ */ a.jsx(fa, { altLogo: n, intl: i, locale: r, localeSelector: d, shouldSendAuthToPage: t, showLogoOnly: u, urlPrefix: S, analyticsTrackFunction: I, setShowSearchNav: N });
};
export {
  Ua as MainNavigation
};
//# sourceMappingURL=index.js.map
